import {PieChart} from '@crema/modules/thirdParty';
export default PieChart;
